import { render } from "./ClickablePicture.vue?vue&type=template&id=4df1c042&ts=true"
import script from "./ClickablePicture.vue?vue&type=script&lang=ts"
export * from "./ClickablePicture.vue?vue&type=script&lang=ts"

import "./ClickablePicture.vue?vue&type=style&index=0&id=4df1c042&lang=scss"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__